import { FunctionComponent } from 'react'
import useStyles from './styles'
import { Link } from '@conexasaude/hero'
import Icon from '@/components/HeroIcons'
import { useHistory } from 'react-router'

import { useThemeGeneratorContext } from '@/theme/contexts/ThemeGeneratorContext'
import useWindowSize from '@/utils/useWindowSize'
import CustomLayout from '@/components/CustomLayout'
import { IConsultationDetailsResponseGroup } from '../../types'
import { useGroupConsultationContext } from '../../contexts/consultationGroupContext'
import { ConsultationGroupCard } from '../../components/ConsultationCardGroup'
import { convertStringIntoDateArray } from '@/utils/date'
import ResumeDoctorGroup from '../../components/ResumeDoctorGroup'

const ConfirmGroupConsultation: FunctionComponent<
  IConsultationDetailsResponseGroup
> = () => {
  const { confirmGroupConsultationWrapper, backLink } = useStyles()
  const { isMobile } = useWindowSize()
  const { push } = useHistory()
  const { embed } = useThemeGeneratorContext()
  const { groupConsultationData } = useGroupConsultationContext()

  return (
    <div css={confirmGroupConsultationWrapper} className="container">
      <CustomLayout>
        {embed.full && !isMobile && (
          <Link onClick={() => push('/')} styles={{ label: backLink }}>
            <Icon
              name="arrow-left-variant"
              themeColor={['extra', 'gray_icon']}
              width="16px"
            />
            Voltar para o início
          </Link>
        )}
        <div className="main-wrapper">
          <Icon name="woman-checkout-confirmed" />
          <h2>Consulta em grupo confirmada com sucesso!</h2>
        </div>
        <h5 className="abstract-title">Resumo</h5>
        <div className="abstract-wrapper">
          <ResumeDoctorGroup
            professionalName={groupConsultationData?.professionalName}
            professionalSpecialty={groupConsultationData?.professionalSpecialty}
          />
          <ConsultationGroupCard
            bodyOnly
            noTag
            readOnly
            theme={groupConsultationData?.theme}
            professionalId={groupConsultationData?.professionalId}
            professionalName={groupConsultationData?.professionalName.toLowerCase()}
            specialty={groupConsultationData?.professionalSpecialty}
            participants={groupConsultationData?.numberParticipants}
            status={groupConsultationData?.status}
            id={groupConsultationData?.id}
            appointmentDate={convertStringIntoDateArray(
              groupConsultationData?.appointmentDate.toString(),
            )}
            patientConfirmation={groupConsultationData?.numberParticipants.toString()}
          />
          <div className="link-footer">
            {isMobile && (
              <Link onClick={() => push('/')}>Voltar para o início</Link>
            )}
          </div>
        </div>
      </CustomLayout>
    </div>
  )
}

export default ConfirmGroupConsultation
